export const SysadminRoleKey = "sysadmin";
export const ReadersRoleKey = "readers";
export const WritersRoleKey = "writers";
export const UnauthenticatedRoleKey = "unauthenticated";
export const LoggedInRoleKey = "logged-in";
export const SignedInRoleKey = "signed-in";
export const SessionRoleFieldKey = "ModelField-Session-Roles";
